config = require 'root/config'

LandingsAPI =
  getList: (data, success, error) ->
    $.ajax {
      url: config.urls.landings.getList
      type: 'GET'
      data
      success
      error
      timeout: 5000
    }

  get: (id, success, error) ->
    $.ajax {
      url: config.urls.landings.get(id)
      type: 'GET'
      success
      error
      timeout: 5000
    }

  create: (data, success, error) ->
    $.ajax {
      url: config.urls.landings.create
      contentType: 'application/json'
      data: JSON.stringify(data)
      type: 'POST'
      success
      error
      timeout: 5000
    }

  update: (data, success, error) ->
    $.ajax {
      url: config.urls.landings.update(data.id)
      contentType: 'application/json'
      data: JSON.stringify(data)
      type: 'PUT'
      success
      error
      timeout: 5000
    }

module.exports = LandingsAPI
